/* eslint-disable camelcase */
import { DATE_FORMAT_PLACEHOLDER } from '~constants/dates';

export const spanishResources = {
  resources: {
    projects: {
      fields: {
        image: 'Imagen',
        image_name: 'Nombre de imagen',
        kml: 'Archivo KML',
        dynamic_center_latitude: 'Latitud del centro',
        dynamic_center_longitude: 'Longitud del centro',
        dynamic_map_zoom: 'Nivel de zoom',
        kml_simplified: 'Archivo KML',
        static_map_lat: 'Latitud del centro',
        static_map_lng: 'Longitud del centro',
        static_map_zoom: 'Nivel de zoom',
        images: 'Imágenes',
        iirsa_countries: 'Países (*)',
        name: 'Nombre (*)',
        code: 'Código (*)',
        createdAt: 'Creación',
        createdAt_desde: 'Creado desde',
        createdAt_hasta: 'Creado hasta',
        totalInvestment_min: 'Inversión minima',
        totalInvestment_max: 'Inversión máxima',
        backTitle: 'Título',
        updatedAt: 'Última modificación',
        updatedAt_desde: 'Modificación desde',
        updatedAt_hasta: 'Modificación hasta',
        totalInvestmentFormatted: 'Inversión total',
        institution: 'Institución',
        first_name: 'Nombre',
        last_name: 'Apellido',
        email: 'Email',
        role: 'Cargo',
        phone: 'Teléfono',
        owners: 'Responsables',
        description: 'Descripción',
        investment: 'Inversión',
        situation: 'Situación',
        iirsa_subsector: 'Subsector (*)',
        iirsa_stage: 'Etapa (*)',
        iirsa_status: 'Estado',
        iirsa_project_type: 'Tipo de Obra (*)',
        iirsa_scope: 'Alcance (*)',
        iirsa_segments: 'Segmento',
        is_bid: 'BID',
        is_caf: 'CAF',
        is_fonplata: 'FONPLATA',
        accompaniment: 'Acompañamiento',
        is_portfolio: 'Portafolio',
        comments: 'Comentarios',
        is_anchor: 'Ancla',
        has_ambiental_license: 'Licencia ambiental',
        iirsa_studies_state: 'Estado de los estudios',
        iirsa_studies_funder: 'Financiador de los estudios',
        studies_finished: 'Estudios finalizados',
        iirsa_project_funding: 'Financiamiento',
        studies_amount: 'Monto de los estudios',
        iirsa_funding_type: 'Tipo de financiamiento',
        iirsa_funding_status: 'Estado del financiamiento',
        amount: 'Monto (*)',
        countries: 'Países',
        stage: 'Etapa',
        iirsa_total_investment_min: 'Inversión mínima',
        iirsa_total_investment_max: 'Inversión máxima'
      }
    },
    searchs: {
      name: 'Búsquedas',
      fields: {
        searchString: 'Término',
        date: 'Fecha',
        section: 'Sección',
        contentType: 'Sección',
        location: 'País',
        country: 'País',
        createdAt: 'Fecha',
        createdAt_desde: 'Creado desde',
        createdAt_hasta: 'Creado hasta',
        investment: 'Inversión',
        totalInvestmentFormatted: 'Inversión',
        infrastructure: 'Infraestructura',
        financing: 'Financiamiento',
        stage: 'Etapa',
        topic: 'Tecnología',
        type_filter: 'Tipo'
      }
    },
    searchsSummary: {
      name: 'Detalle de búsquedas',
      fields: {
        date: 'Fecha',
        searchString: 'Término',
        count: 'Cantidad'
      }
    },
    routes: {
      name: 'Agrupación de proyectos |||| Agrupaciones de proyectos'
    },
    topics: {
      name: 'Temas',
      fields: {
        title: 'Título'
      }
    },
    priorizaciones: {
      name: 'Priorizaciones',
      fields: {
        id: 'ID',
        name: 'Nombre (ES)',
        nameEs: 'Nombre (ES)',
        nameEn: 'Nombre (EN)',
        namePt: 'Nombre (PT)'
      }
    },
    etapas: {
      name: 'Etapas',
      fields: {
        id: 'ID',
        name: 'Nombre (ES)',
        nameEs: 'Nombre (ES)',
        nameEn: 'Nombre (EN)',
        namePt: 'Nombre (PT)',
        weight: 'Peso (%)',
        subStages: 'Sub-etapas'
      }
    },
    'project-tracking': {
      name: 'Seguimiento',
      fields: {
        lastUpdate: 'Fecha de última actualización',
        description: 'Descripción del estado de situación',
        stage: 'Etapa',
        weight: 'Peso (%)',
        progress: 'Avance (%)',
        startDate: 'Fecha de inicio',
        expectedEndDate: 'Finalización esperada'
      }
    },
    alcances: {
      name: 'Alcances',
      fields: {
        id: 'ID',
        name: 'Nombre (ES)',
        nameEs: 'Nombre (ES)',
        nameEn: 'Nombre (EN)',
        namePt: 'Nombre (PT)'
      }
    },
    'estados-estudios': {
      name: 'Estados de Estudios',
      fields: {
        id: 'ID',
        name: 'Nombre (ES)',
        nameEs: 'Nombre (ES)',
        nameEn: 'Nombre (EN)',
        namePt: 'Nombre (PT)'
      }
    },
    estados: {
      name: 'Estados',
      fields: {
        id: 'ID',
        name: 'Nombre (ES)',
        nameEs: 'Nombre (ES)',
        nameEn: 'Nombre (EN)',
        namePt: 'Nombre (PT)'
      }
    },
    'financiadores-estudios': {
      name: 'Financiadores de Estudios',
      fields: {
        id: 'ID',
        name: 'Nombre (ES)',
        nameEs: 'Nombre (ES)',
        nameEn: 'Nombre (EN)',
        namePt: 'Nombre (PT)'
      }
    },
    paises: {
      name: 'Países',
      fields: {
        id: 'ID',
        name: 'Nombre',
        flag: 'Bandera'
      }
    },
    sectores: {
      name: 'Sectores',
      fields: {
        id: 'ID',
        name: 'Nombre (ES)',
        nameEs: 'Nombre (ES)',
        nameEn: 'Nombre (EN)',
        namePt: 'Nombre (PT)'
      }
    },
    subsectores: {
      name: 'Subsectores',
      fields: {
        id: 'ID',
        name: 'Nombre (ES)',
        nameEs: 'Nombre (ES)',
        nameEn: 'Nombre (EN)',
        namePt: 'Nombre (PT)',
        sector: 'Sector'
      }
    },
    'tipos-proyecto': {
      name: 'Tipos de Proyecto',
      fields: {
        id: 'ID',
        name: 'Nombre (ES)',
        nameEs: 'Nombre (ES)',
        nameEn: 'Nombre (EN)',
        namePt: 'Nombre (PT)',
        subsector: 'Subsector'
      }
    },
    metrics: {
      name: 'Métricas',
      fields: {
        id: 'ID',
        name: 'Nombre',
        slug: 'Identificador',
        unit: 'Unidad',
        category: 'Categoría'
      }
    },
    'metric-values': {
      name: 'Valores de Métricas',
      fields: {
        id: 'ID',
        metric: 'Métrica',
        pais: 'País',
        etapa: 'Etapa',
        subsector: 'Subsector',
        value: 'Valor',
        detalle: 'Detalle'
      }
    },
    disclaimers: {
      name: 'Disclaimers',
      fields: {
        id: 'ID',
        titleEs: 'Título (ES)',
        titleEn: 'Título (EN)',
        titlePt: 'Título (PT)',
        disclaimerEs: 'Disclaimer (ES)',
        disclaimerEn: 'Disclaimer (EN)',
        disclaimerPt: 'Disclaimer (PT)',
        order: 'Orden'
      }
    }
  },
  fieldGroups: {
    contentInformation: 'Datos básicos de la publicación',
    mainContent: 'Contenido de la publicación',
    additionalInformation: 'Información adicional de la publicación',
    authorInfo: 'Autor del material',
    contentConfiguration: 'Configuración de sistema',
    date: 'Fecha del material',
    contentType: 'Tipo de contenido',
    originalSource: 'Fuente (Opcional)',
    sourceUrl: 'Enlace a publicación original (Opcional)',
    starred: 'Destacado (Opcional)',
    dropImage: 'Arrastre la imágen aquí',
    dropVideo: 'Arrastre el video aquí',
    authorName: 'Nombre (Opcional)',
    authorLastName: 'Apellido (Opcional)',
    authorEmail: 'Email (Opcional)',
    authorInstitution: 'Institución (Opcional)',
    authorRole: 'Rol (Opcional)',
    eventInformation: 'Datos básicos del evento',
    extraEventInformation: 'Información adicional del evento',
    eventAbout: '¿De qué trata el evento?',
    eventDescription: 'Descripción corta (*)',
    eventContent: 'Contenido',
    eventSessions: 'Fechas del evento',
    startMoment: 'Hora de inicio',
    endMoment: 'Hora de fin',
    publicationStatus: 'Estado de publicación',
    topics: 'Temas',
    topic: 'Tema',
    projectInformation: 'Datos básicos del proyecto',
    dynamicMap: 'Mapa dinámico',
    staticMap: 'Mapa estático',
    projectDocuments: 'Documentos',
    projectImages: 'Imágenes',
    projectLinks: 'Enlaces',
    sources: 'Financiamiento',
    owners: 'Responsables',
    auditInformation: 'Auditoría',
    projectSections: 'Tramos',
    projectFunding: 'Financiamiento',
    galleryItems: 'Items de galeria',
    infrastructure: 'Infraestructura',
    scope: 'Alcance',
    ilat: 'ILAT',
    general: 'General',
    projectStatus: 'Estado del proyecto',
    comments: 'Comentarios',
    routeInformation: 'Datos de la agrupación de proyectos',
    routeMap: 'Mapa del área de la agrupación de proyectos',
    routes: 'Agrupaciones de proyectos',
    routeEs: 'Español',
    routeEn: 'English',
    routePt: 'Português',
    priorizacion: 'Información de Priorización',
    priorizacionEs: 'Español',
    priorizacionEn: 'English',
    priorizacionPt: 'Português',
    etapa: 'Información de Etapa',
    etapaEs: 'Español',
    etapaEn: 'English',
    etapaPt: 'Português',
    etapaSubStages: 'Sub-etapas (en orden)',
    trackingStatus: 'Estado de situación',
    trackingStages: 'Avance por etapa',
    alcance: 'Información de Alcance',
    alcanceEs: 'Español',
    alcanceEn: 'English',
    alcancePt: 'Português',
    estadoEstudios: 'Información de Estado de Estudios',
    estadoEstudiosEs: 'Español',
    estadoEstudiosEn: 'English',
    estadoEstudiosPt: 'Português',
    estado: 'Información de Estado',
    estadoEs: 'Español',
    estadoEn: 'English',
    estadoPt: 'Português',
    financiadorEstudios: 'Información de Financiador de Estudios',
    financiadorEstudiosEs: 'Español',
    financiadorEstudiosEn: 'English',
    financiadorEstudiosPt: 'Português',
    pais: 'Información de País',
    sector: 'Información de Sector',
    sectorEs: 'Español',
    sectorEn: 'English',
    sectorPt: 'Português',
    subsector: 'Información de Subsector',
    subsectorEs: 'Español',
    subsectorEn: 'English',
    subsectorPt: 'Português',
    tipoProyecto: 'Información de Tipo de Proyecto',
    tipoProyectoEs: 'Español',
    tipoProyectoEn: 'English',
    tipoProyectoPt: 'Português',
    metric: 'Información de Métrica',
    metricValue: 'Información de Valor de Métrica',
    disclaimer: 'Información del Disclaimer',
    disclaimerEs: 'Español',
    disclaimerEn: 'English',
    disclaimerPt: 'Português'
  },
  auth: {
    credentialsError: 'Credenciales erroneas',
    noBackofficeAccess: 'Su usuario no tiene acceso al backoffice'
  },
  provider: {
    invalidAction: 'Acción invalida'
  },
  common: {
    actions: 'Acciones',
    starred: 'Destacado',
    notStarred: 'No Destacado',
    draft: 'Borrador',
    published: 'Publicado',
    unpublished: 'No Publicado',
    videoLink: 'Ver video',
    filters: {
      creationDateRangeStart: 'Creación desde',
      creationDateRangeEnd: 'Creación hasta',
      durationDateRangeStart: 'Fecha desde',
      durationDateRangeEnd: 'Fecha hasta'
    },
    contentTypes: {
      event: 'Evento',
      project: 'Proyecto',
      energy: 'Energía',
      transport: 'Transporte y logística',
      boundary: 'Fronteras',
      telecommunications: 'Telecomunicaciones',
      article: 'Artículo',
      workshop: 'Taller'
    },
    eventTypes: {
      workshop: 'Taller',
      meeting: 'Webinar',
      conference: 'Conferencia',
      training: 'Capacitación',
      seminar: 'Seminario'
    },  
    areaTypes: {
      nacional: 'Nacional',
      binacional: 'Binacional'
    },
    sections: {
      event: 'Eventos',
      project: 'Proyectos',
      all: 'Home',
      article: 'Contenidos'
    },
    topics: {
      bim: 'BIM',
      blockchain: 'Blockchain',
      artificialintelligence: 'Inteligencia Artificial',
      iot: 'Internet de las Cosas',
      bigdata: 'Big Data'
    },
    image: {
      epigraph: 'Epígrafe'
    }
  },
  buttons: {
    draft: 'Marcar como borrador',
    publish: 'Publicar',
    unpublish: 'Marcar como no publicado',
    promote: 'Convertir en Proyecto',
    tracking: 'Seguimiento',
    edit: 'Editar',
    recomputeMetrics: 'Recalcular todas las métricas',
    reprocessLayer: 'Reprocesar',
    republishLayer: 'Republicar'
  },
  metrics: {
    recomputeStarted: 'Recálculo de métricas iniciado',
    recomputeError: 'No se pudo iniciar el recálculo de métricas',
    recomputeInProgress: 'Recálculo de métricas en curso…'
  },
  layers: {
    reprocessStarted: 'Reingesta de la capa iniciada',
    reprocessError: 'No se pudo iniciar la reingesta',
    republishStarted: 'Publicación en GeoServer iniciada',
    republishError: 'No se pudo iniciar la publicación'
  },
  projectsLayer: {
    saved: 'Configuración guardada; la capa se está republicando',
    rebuildStarted: 'Reconstrucción de la capa de proyectos iniciada',
    rebuildError: 'No se pudo iniciar la reconstrucción'
  },
  errors: {
    fileUpload: 'Hubo un error al subir los archivos, por favor intenta nuevamente.',
    maxLength: 'Máximo %{count} caracteres',
    required: 'Campo requerido',
    email: 'Ingrese un email válido',
    date: `Ingrese una fecha válida en el formato ${DATE_FORMAT_PLACEHOLDER}`,
    duplicateCountries: 'Hay países repetidos'
  },
  ra: {
    auth: {
      user_menu: 'Perfil', // eslint-disable-line camelcase
      logout: 'Cerrar sesión'
    }
  },
  appBar: {
    menu: 'Menú'
  },
  login: {
    Username: 'Nombre de usuario',
    Password: 'Contraseña',
    Continue: 'Continuar'
  },
  userType: {
    administrator: 'Administrador',
    editor: 'Editor',
    read_only: 'Solo lectura',
    country_manager: 'Gestor de país',
    super_admin: 'Super administrador'
  }
};
